import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import { Pnr } from '../../modal';

import * as ActionPnr from './action';

@Injectable()
export class PnrEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  loadAction$ = createEffect(() => this.actions$
    .pipe(
      ofType<ActionPnr.PostPnrRequest>(ActionPnr.POST_Pnr),
      map(action => {return action.payload as any}),
      
    ));
  private handleError(error) {
    return of(new ActionPnr.Error(error));
  }
}
